var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStar = function SvgStar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 20,
    "data-width-72": 59,
    viewBox: "0 0 20 19",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeOpacity: 0.7,
    d: "M9.499.5a1.32 1.32 0 0 1 1.182.73v.001l1.58 3.2a2.11 2.11 0 0 0 1.573 1.154h.009l3.587.48a1.31 1.31 0 0 1 .724 2.234l-2.61 2.49-.007.007a2.13 2.13 0 0 0-.602 1.855l.002.004.61 3.52v.002a1.3 1.3 0 0 1-.52 1.278l-.004.003a1.3 1.3 0 0 1-1.38.1h-.001l-3.16-1.66-.005-.003a2.15 2.15 0 0 0-1.955 0l-.005.003-3.16 1.66h-.002a1.309 1.309 0 0 1-1.903-1.381l.61-3.49v-.005a2.13 2.13 0 0 0-.6-1.857l-.004-.003-2.56-2.49a1.31 1.31 0 0 1 .723-2.237l3.54-.51.009-.001a2.11 2.11 0 0 0 1.572-1.193l1.575-3.158A1.32 1.32 0 0 1 9.5.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export default ForwardRef;